import baseUrl from "../../../utils/baseUrl";
import getToken from "../../../utils/getToken";

export default async function SwipedBuddyPreference(userProfileId) {
  if(!userProfileId) return;

  return fetch(baseUrl() + `/api/v1/buddy_preferences/swiped`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getToken(),
    },
    body: JSON.stringify({
      buddy_preference: {
        user_profile_id: userProfileId,
      },
    }),
  })
}
